import { Badge } from '@/components/ui/badge'
import { draftStatusBadgeStyles, draftStatusLabels } from '@/lib/constants/draft'
import type { DraftStatus } from '@/lib/api/types'

interface DraftStatusBadgeProps {
  status: DraftStatus
  scheduledAt?: string | null
}

export function DraftStatusBadge({ status, scheduledAt }: DraftStatusBadgeProps) {
  // Derive display status: approved + scheduledAt = scheduled
  const displayStatus: DraftStatus = status === 'approved' && scheduledAt ? 'scheduled' : status

  return (
    <Badge
      variant="secondary"
      className={`font-semibold ${draftStatusBadgeStyles[displayStatus]}`}
    >
      {draftStatusLabels[displayStatus]}
    </Badge>
  )
}
